import * as React from 'react';
import {connect} from 'react-redux';
import * as ReportModule from 'Modules/ReportModule';
import {withTranslation} from 'react-i18next';
import {ParentDetails, CustomProps, IParentDetailsProps} from 'components/Layout/DetailsSidebar/ParentDetails';
import {VehicleStateReportParam} from 'Models/ReportModel'

interface IP extends IParentDetailsProps {
    history: any;
}

type ConnectedP = {
    reportStore: ReportModule.Types.ReportStore;
};
type DispatchedP = {
    getVehiclesStateReport: (params: VehicleStateReportParam) => void;
    getReportFile: (extension: ReportModule.EnumTypes.ReportExtension, type: ReportModule.EnumTypes.ReportType, params?: URLSearchParams) => void;
    t?: (key: string) => string;
};
type S = {};

class VehiclesStateReportDetails extends ParentDetails<IP & ConnectedP & DispatchedP, S> {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public getCustomProps(): CustomProps {
        return {
            ...(this.props as any),
            extrnalRender: () => this.extrnalRender()
        };
    }

    private async handleSubmit() {
        const {getVehiclesStateReport} = this.getCustomProps();
        await getVehiclesStateReport();
    }

    private extrnalRender() {
        const {getReportFile, reportStore, t, submitting, pristine} = this.getCustomProps();
        const {PDF, CSV, XLSX} = ReportModule.EnumTypes.ReportExtension;
        const {VEHICLES_STATE_REPORT} = ReportModule.EnumTypes.ReportType;
        return (
            <>
                <button disabled={submitting || pristine} className="btn btn--blue mt-20" onClick={this.handleSubmit}>
                    {t('generateReport')}
                </button>

                <div className="report__generate-file">
                    <button disabled={reportStore.vehiclesStateReport === null}
                            className="report__button btn btn--clean"
                            onClick={() => getReportFile(PDF, VEHICLES_STATE_REPORT)}>
                        <img src={'/images/icons/pdf_icon.svg'} alt="PDF" className="report__button-img"/>
                        <span>{t('exportToPDF')}</span>
                    </button>
                    <button disabled={reportStore.vehiclesStateReport === null}
                            className="report__button btn btn--clean"
                            onClick={() => getReportFile(CSV, VEHICLES_STATE_REPORT)}>
                        <img src={'/images/icons/csv_icon.svg'} alt="CSV" className="report__button-img"/>
                        <span>{t('exportToCSV')}</span>
                    </button>
                    <button disabled={reportStore.vehiclesStateReport === null}
                            className="report__button btn btn--clean"
                            onClick={() => getReportFile(XLSX, VEHICLES_STATE_REPORT)}>
                        <img src={'/images/icons/xls_icon.svg'} alt="XLS" className="report__button-img"/>
                        <span>{t('exportToXLS')}</span>
                    </button>
                </div>
            </>
        );
    }
}

function mapStateToProps(state: any): ConnectedP {
    return {
        reportStore: state.reportStore
    };
}

function mapDispachToProps(dispatch: any): DispatchedP {
    return {
        getVehiclesStateReport: (params) => dispatch(ReportModule.Actions.getVehiclesStateReport(params)),
        getReportFile: (extension: ReportModule.EnumTypes.ReportExtension, type: ReportModule.EnumTypes.ReportType, params?: URLSearchParams) =>
            dispatch(ReportModule.Actions.getReportFile(extension, type, params)),
    };
}

export default withTranslation('reports')(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(VehiclesStateReportDetails) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Layout/DetailsSidebar/VehiclesStateReportDetails.tsx